import { render, staticRenderFns } from "./ProductContent.vue?vue&type=template&id=4b22d922&scoped=true&"
import script from "./ProductContent.vue?vue&type=script&lang=js&"
export * from "./ProductContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductContent.vue?vue&type=style&index=0&id=4b22d922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b22d922",
  null
  
)

export default component.exports